// extracted by mini-css-extract-plugin
module.exports = {"smallPadd":"Video_smallPadd__Jgf4h","paragraph":"Video_paragraph___3V5F","button":"Video_button__oSKFD"};